import React, { useEffect, useRef, useState } from "react";
import Fade from "react-reveal/Fade";

const VIDEO_DESKTOP = encodeURI("/files/Yeksina HOME_08-2026_Site_HD.mp4");
const VIDEO_MOBILE = encodeURI("/files/Yeksina HOME_08-2026_RS_HD.mp4");
const POSTER_DESKTOP = encodeURI("/images/inspirations-poster-site.jpg");
const POSTER_MOBILE = encodeURI("/images/inspirations-poster-rs.jpg");
const MOBILE_BREAKPOINT = 1024;

/**
 * Section "Nos Inspirations" - Affiche une vidéo centrée avec image de couverture
 */
const InspirationsSection: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showControls, setShowControls] = useState(false);
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.innerWidth <= MOBILE_BREAKPOINT
  );

  useEffect(() => {
    const checkIsMobile = () =>
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  const videoSrc = isMobile ? VIDEO_MOBILE : VIDEO_DESKTOP;
  const posterSrc = isMobile ? POSTER_MOBILE : POSTER_DESKTOP;

  useEffect(() => {
    setIsPlaying(false);
    setShowControls(false);
  }, [videoSrc]);

  const handlePlayClick = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
      setShowControls(true);
    }
  };

  const handleVideoPause = () => {
    setIsPlaying(false);
  };

  const handleVideoPlay = () => {
    setIsPlaying(true);
    setShowControls(true);
  };

  return (
    <section className="inspirations-section my-5">
      <div className="container-easy-market">
        <div className="inspirations-content">
          <Fade bottom>
            <h2 className="inspirations-title">NOS INSPIRATIONS</h2>
          </Fade>
          <Fade bottom delay={100}>
            <div
              className={`inspirations-video-wrapper${
                isMobile ? " is-mobile" : ""
              }`}
            >
              <video
                key={videoSrc}
                ref={videoRef}
                className="inspirations-video"
                controls={showControls}
                poster={posterSrc}
                preload="metadata"
                playsInline
                onPlay={handleVideoPlay}
                onPause={handleVideoPause}
              >
                <source src={videoSrc} type="video/mp4" />
                Votre navigateur ne supporte pas la lecture de vidéos.
              </video>
              {!isPlaying && (
                <button
                  className="inspirations-play-button"
                  onClick={handlePlayClick}
                  aria-label="Lire la vidéo"
                >
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 80 80"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="40" cy="40" r="40" fill="rgba(0, 0, 0, 0.6)" />
                    <path
                      d="M32 24L32 56L56 40L32 24Z"
                      fill="#fff"
                    />
                  </svg>
                </button>
              )}
            </div>
          </Fade>
        </div>
      </div>
    </section>
  );
};

export default InspirationsSection;
